function CruTerms() {
  return (
    <div style={{ maxWidth: 720, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', lineHeight: 1.7, color: '#222' }}>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 4, color: '#2C5F2E' }}>Cru — Terms of Service</h1>
      <p style={{ color: '#666', marginTop: 0, marginBottom: 32 }}>Last updated: July 2026</p>

      <p>
        By using Cru ("the App"), you agree to these terms. If you do not agree, do not use the App.
      </p>

      <h2>Use of the App</h2>
      <p>
        The App is provided for personal, non-commercial use to discover and share bike-friendly
        cafés. You must be at least 13 years old to use the App.
      </p>

      <h2>Submitting content</h2>
      <p>
        The App has no accounts — anyone can submit a café for review. By submitting a café,
        photos, or other content, you confirm that the information is accurate to the best of
        your knowledge, that you have the right to share any photos you upload, and you grant us
        the right to display that content publicly within the App once it is verified.
      </p>
      <p>
        We manually review submissions before they appear on the map, and may edit, reject, or
        remove any submission at our discretion — including after it has been published.
      </p>

      <h2>Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Submit false, misleading, or offensive content</li>
        <li>Use the App for any unlawful purpose</li>
        <li>Attempt to disrupt or abuse the submission or review process</li>
      </ul>

      <h2>Accuracy of information</h2>
      <p>
        Café details (opening hours, amenities, contact information) are crowd-sourced and may be
        inaccurate or out of date. Verify details independently before relying on them, especially
        for time-sensitive plans.
      </p>

      <h2>Availability</h2>
      <p>
        We provide the App on a best-effort basis. We may suspend, modify, or discontinue the App
        at any time without notice. We are not liable for any loss resulting from unavailability
        of the App.
      </p>

      <h2>Disclaimer of warranties</h2>
      <p>
        The App is provided "as is" without warranties of any kind, express or implied. We do not
        guarantee that the App, or the accuracy of any café listed in it, will be error-free.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, we are not liable for any indirect, incidental, or
        consequential damages arising from your use of the App.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by the laws of England and Wales.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms at any time. The "Last updated" date above will reflect the most
        recent change. Continued use of the App after a change constitutes acceptance of the
        updated terms.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms:&nbsp;
        <a href="mailto:dennis.hvel@gmail.com">dennis.hvel@gmail.com</a>
      </p>
    </div>
  );
}

export default CruTerms;
